/** @format */

import SearchIcon from '@mui/icons-material/Search';
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from '@mui/material';
import React, { ChangeEvent } from 'react';

interface Props {
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  search: string;
}

/** Search text only; parent composes filtering with stage / year / outcome chips. */
export default function SearchBar({ setSearch, search }: Props) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value.toLowerCase());
  };

  return (
    <FormControl
      sx={{ width: '100%', mb: 0 }}
      variant="outlined"
      size="small"
      fullWidth>
      <InputLabel htmlFor="outlined-adornment-password" size="small">
        Search Applicants
      </InputLabel>
      <OutlinedInput
        name="searchApplicants"
        value={search}
        onChange={handleChange}
        id="outlined-adornment-password"
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="toggle password visibility" edge="end">
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        }
        label="Search Applicants"
      />
    </FormControl>
  );
}
